import React, { useState, useEffect, useContext } from "react";
import {
  createBulkQuotation,
  getCustomers,
  getTax,
  getUnits,
  getManufacturers,
  getWarehouseProduct,
  getproductvalue,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import ProductForm from "../Product/Form";
import { WarehouseContext } from "../../../Utility/UserContext";
import { generateRandomCode } from "../../../Utility/function";
import "../Purchase/dropdown.css";
import {
  InputField,
  NewCommonCardUi,
  SelectOption,
} from "../../Common/CommonCard";
import SupplierForm from "../Suppliers/form";
import { useLocation, useNavigate } from "react-router-dom";

const EditQuotation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [taxes, setTax] = useState([]);
  const [Units, setUnits] = useState([]);
  const [products, setProducts] = useState([]); // To store all products
  const [filteredProducts, setFilteredProducts] = useState([]); // To store filtered products
  const [filteredSuppliers, setFilteredSuppliers] = useState([]); // To store filtered products
  const [supplier, setSupplier] = useState([]);
  const [SupplierId, setSupplierId] = useState(0);
  const [Manufacturers, setManufacturers] = useState([]);
  const { selectedWarehouse } = useContext(WarehouseContext);
  const [unqui, setunqui] = useState();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [supplierdata, setsupplierData] = useState();
  const [productdata, setproductData] = useState();
  const { showLoader, hideLoader, shopItem, UserItem } =
  useContext(WarehouseContext);
  const [AuthUser, setAuthUser] = useState(UserItem);

  const [discount, setDiscount] = useState(0);
  const [vat, setVat] = useState(0);
  const [freightCharges, setFreightCharges] = useState(0);
  const [otherCharges, setOtherCharges] = useState(0);
  const [roundoff, setRoundOff] = useState(0);
  const [previousDue, setPreviousDue] = useState(0);

  const [formData, setformData] = useState({
    warehouse_id: selectedWarehouse?.id,
    invoice_no: "",
    invoice_date: "",
    ref_1: "",
    ref_2: "",
    purchase_unit: "1",
    tax_type: "",
    remark: "",
    supplier_invoice_no: "",
    supplier_invoice_date: "",
    product_id: "",
    supplier_id: "",
    purchase_price: "",
    qty: "",
    total_amount: "",
    sales_price: "",
    manufactured_date: "",
    expiry_date: "",
    manufacturer_id: "",
    box_sales_cost: "",
  });

  useEffect(() => {
    setunqui(generateRandomCode());
    fetchSuppliers();
    fetchManufacturers();
    fetchTax();
    fetchUnit();
    if (state) {
      console.log("data", state);
      setformData({
        ...formData,
        invoice_no: "",
        invoice_date: state.date,
        ref_1: "",
        ref_2: "",
        purchase_unit: "1",
        tax_type: state.tax_type,
        remark: "",
        supplier_invoice_no: "",
        supplier_invoice_date: "",
        product_id: state.product_id,
        supplier_id: state.supplier_id,
        purchase_price: state.purchase_price,
        qty: state.qty,
        sub_total: state.sub_total,
        total_amount: state.total,
        sales_price: state.sales_price,
        manufactured_date: state.manufactured_date,
        expiry_date: "",
        manufacturer_id: "",
        box_sales_cost: state.box_sales_cost,
        customer_name: state.customer_name,
    product_name:state.product_name,
    item_code:state.item_code,
    warehouse_id: "",
   
    storage_type: state.storage_type,
      });
      setFreightCharges(state.freight_charges);
      setDiscount(state.discount);
      setOtherCharges(state.other_charges);
      setPreviousDue(state.previous_due);
      setVat(state.vat);
      setSupplierId(state.supplier_id);
      setRoundOff(state.round_off);
    }
  }, []);


  const fetchUnit = async () => {
    try {
      const response = await getUnits();
      if (response.data && response.data.data) {
        setUnits(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Customers data:", error);
    }
  };

  const fetchTax = async () => {
    try {
      const response = await getTax();
      if (response.data && response.data.data) {
        setTax(response.data.data);
      } else {
        toast.error("No Tax found.");
      }
    } catch (error) {
      console.error("Error fetching Tax:", error);
      toast.error("Error fetching Tax");
    }
  };

  useEffect(() => {
    if (!selectedWarehouse?.id) {
      toast.warning("Select a Warehouse before Entry");
    }
    fetchProducts(selectedWarehouse?.id);
  }, [selectedWarehouse]);

  const fetchSuppliers = async () => {
    try {
      const response = await getCustomers();
      if (response.data && response.data.data) {
        setSupplier(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
    }
  };

  const fetchManufacturers = async () => {
    try {
      const response = await getManufacturers(1);
      if (response.data && response.data.data) {
        setManufacturers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Customers data:", error);
    }
  };

  const fetchProducts = async (ware_id = selectedWarehouse?.id) => {
    try {
      const response = await getproductvalue(ware_id,true);
      if (response.data && response.data.data) {
        setProducts(response.data.data);
        setFilteredProducts(response.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // const fetchProducts = async (id = selectedWarehouse?.id) => {
  //     try {
  //         const response = await getWarehouseProduct(id);
  //         if (response.data && response.data.data) {
  //             setProducts(response.data.data);
  //             setFilteredProducts(response.data.data);
  //         }
  //     } catch (error) {
  //         console.error('Error fetching products:', error);
  //     }
  // };

  const [inputValue, setInputValue] = useState("");
  const [SupplierValue, setSupplierValue] = useState("");
  const [rows, setRows] = useState([]);
  const [editingRow, setEditingRow] = useState(null);


  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
    setRows(updatedRows);
  };

//   const handleAddRow = () => {
//     const requiredFields = [
//       "product_id",
//       "qty",
//       "manufactured_date",
//       "expiry_date",
//     ];
//     const missingFields = requiredFields.filter((field) => !formData[field]);
//     if (missingFields.length > 0) {
//       toast.error(
//         `Please fill out the following fields: ${missingFields.join(", ")}`
//       );
//       return;
//     }
//     if (formData.qty <= 0) {
//       toast.error(`Qty must be greater then 0`);
//       return;
//     }
//     const isProductDuplicate = rows.some(
//       (row) => row.product_id === formData.product_id
//     );
//     if (isProductDuplicate) {
//       toast.error("This product is already added.");
//       return;
//     }
//     const newRow = {
//       id: rows.length + 1,
//       product_id: formData.product_id,
//       supplier_id: formData.supplier_id,
//       manufacturer_id: formData.manufacturer_id,
//       qty: formData.qty,
//       warehouse_id: selectedWarehouse?.id,
//       product_name: productdata.product_name,
//       item_code: productdata.product_code,
//       purchase_price: formData.purchase_price,
//       total_amount: formData.total_amount,
//       sales_price: formData.sales_price,
//       manufactured_date: formData.manufactured_date,
//       expiry_date: formData.expiry_date,
//       storage_type: productdata.storage_type,
//       purchase_unit: formData.purchase_unit,
//     };
//     setRows([...rows, newRow]);
//     setformData({
//       ...formData,
//       remark: "",
//       supplier_invoice_no: "",
//       supplier_invoice_date: "",
//       product_id: "",
//       supplier_id: formData.supplier_id,
//       purchase_price: "",
//       qty: "",
//       total_amount: "",
//       sales_price: "",
//       manufactured_date: "",
//       expiry_date: "",
//       manufacturer_id: "",
//       warehouse_id: selectedWarehouse?.id,
//     });
//     setInputValue("");
//     setproductData();
//   };

const handleAddRow = () => {
    const requiredFields = [
      "product_id",
      "qty",
      "manufactured_date",
      "expiry_date",
    ];
    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      toast.error(
        `Please fill out the following fields: ${missingFields.join(", ")}`
      );
      return;
    }

    if (formData.qty <= 0) {
      toast.error(`Qty must be greater than 0`);
      return;
    }

    // Check if updating an existing row
    if (editingRow !== null) {
      const updatedRows = rows.map((row, index) =>
        index === editingRow ? { ...row, ...formData } : row
      );
      setRows(updatedRows);
      setEditingRow(null); // Reset editing mode
    } else {
      // Check for duplicate product
      const isProductDuplicate = rows.some(
        (row) => row.product_id === formData.product_id
      );
      if (isProductDuplicate) {
        toast.error("This product is already added.");
        return;
      }

      const newRow = {
        id: rows.length + 1,
        product_id: formData.product_id,
        supplier_id: formData.supplier_id,
        manufacturer_id: formData.manufacturer_id,
        qty: formData.qty,
        warehouse_id: selectedWarehouse?.id,
        product_name: productdata?.product_name,
        item_code: productdata?.product_code,
        purchase_price: formData.purchase_price,
        total_amount: formData.total_amount,
        sales_price: formData.sales_price,
        manufactured_date: formData.manufactured_date,
        expiry_date: formData.expiry_date,
        storage_type: productdata?.storage_type,
        purchase_unit: formData.purchase_unit,
      };

      setRows([...rows, newRow]);
    }

    // Reset form fields after adding/updating
    setformData({
      ...formData,
      remark: "",
      supplier_invoice_no: "",
      supplier_invoice_date: "",
      product_id: "",
      supplier_id: formData.supplier_id,
      purchase_price: "",
      qty: "",
      total_amount: "",
      sales_price: "",
      manufactured_date: "",
      expiry_date: "",
      manufacturer_id: "",
      warehouse_id: selectedWarehouse?.id,
    });

    setInputValue("");
    setproductData(null);
  };

  const handleEditRow = (index) => {
    const selectedRow = rows[index];
    setEditingRow(index);
    setformData({ ...selectedRow });
};


  const handleInputChange = (index, field, value) => {
    const updatedRows = rows.map((row, rowIndex) =>
      rowIndex === index ? { ...row, [field]: value } : row
    );
    setRows(updatedRows);
  };

  const handleProductChange = async (index, value) => {
    setInputValue(value);
    if (value === "") {
      setFilteredProducts(products);
    } else {
      const filtered = products.filter((product) =>
        product.product_name?.toLowerCase().includes(value?.toLowerCase())
      );
      setFilteredProducts(filtered);
    }

    const selectedProduct = filteredProducts.find(
      (product) => product.product_name?.toLowerCase() === value?.toLowerCase()
    );

    if (selectedProduct) {
      const updatedRows = rows.map((row, rowIndex) =>
        rowIndex === index
          ? { ...row, product_id: selectedProduct.product_id }
          : row
      );
      setRows(updatedRows);
      setFilteredProducts([]);
    }
  };

  const handleSupplierChange = (index, value) => {
    setSupplierValue(value);

    if (value === "") {
      setFilteredSuppliers(supplier.filter(item => item.status != 1));
    } else {
      const filtered = supplier.filter(supplier =>
       supplier.status != 1 && supplier.name?.toLowerCase().includes(value?.toLowerCase())
      );
      setFilteredSuppliers(filtered);
    }

    const selectedSuppliers = filteredSuppliers.find(
      (supplier) => supplier.name?.toLowerCase() === value?.toLowerCase()
    );

    if (selectedSuppliers) {
      const updatedRows = rows.map((row, rowIndex) =>
        rowIndex === index
          ? { ...row, customer_id: selectedSuppliers.customer_id }
          : row
      );
      setRows(updatedRows);
      setFilteredSuppliers([]);
    }
  };

  const clearData = () => {
    setRows([
      {
        id: 1,
        product_id: "",
        manufacturer_id: "",
        brands_id: "",
        qty: "",
        supplier_id: "",
        warehouse_id: selectedWarehouse?.id,
      },
    ]);
    setSupplierId();
  };

  const HandleSubmit = async () => {
    // console.log(formData);
    // return;
    showLoader();
    try {
      if (rows.length <= 0) {
        toast.error("Add item before Add Purchase order");
        return;
      }
      if (!SupplierId) {
        toast.error("Required Supplier");
        hideLoader();
        return;
      }
      const saveObjectOld = {
        user_id: AuthUser?.user_id,
        supplier_id: SupplierId,
        data: rows,
        po_id: state.quotation_number,
        discount: discount,
        vat: vat,
        freight_charges: freightCharges,
        other_charges: otherCharges,
        total: getTotal(),
        round_off: roundoff,
        shop_id: shopItem?.shop_id || "0",
        created_by: UserItem?.user_id || "0",
      };

      const saveObject = {
        user_id: AuthUser?.user_id,
        supplier_id: SupplierId,
        data: rows,
        po_id: state.quotation_number,
        sub_total: getTotal().sub_total,
        purchase_unit: formData.purchase_unit,
        discount: discount,
        vat: vat,
        freight_charges: freightCharges,
        other_charges: otherCharges,
        previous_due: previousDue,
        total: getTotal().total,
        round_off: getTotal().roundOff,
        grand_total: getTotal().grandTotal,
        balance: getTotal().balance,
        shop_id: shopItem?.shop_id || "0",
        created_by: UserItem?.user_id || "0",
      };
      const Data = await createBulkQuotation(saveObject);
      if (Data?.data.status === "success") {
        toast.success("Purchase Order added successfully");
        hideLoader();
        window.location.href = "/Quotation_list";
      }
    } catch (error) {
      if (error.response?.data?.errors) {
        toast.error(`Error in row ${error.response?.data?.errors}`);
        hideLoader();
      } else {
        toast.error("Error saving Order: Something went wrong");
      }
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [showSupplierModal, setshowSupplierModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setshowSupplierModal(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (
      name === "qty" &&
      value &&
      parseInt(productdata?.total_remaining_qty) < parseInt(value)
    ) {
      return;
    }

    if (name === "product_id") {
      setInputValue(e.target?.pro_name);
      // if(rows.some(item => item.product_id == value)){
      //     return
      // }
      setFilteredProducts([]);
    }
    if (name === "customer_id") {
      setSupplierValue(e.target?.pro_name);
      setSupplierId(e.target?.value);
      setFilteredSuppliers([]);
    }
    setformData({ ...formData, [name]: value });

    if (name == "sales_price") {
      setformData({
        ...formData,
        ["total_amount"]: formData.qty * value,
        [name]: value,
      });
    } else if (name == "qty") {
      setformData({
        ...formData,
        ["total_amount"]: (formData.sales_price || 0) * value,
        [name]: value,
      });
    }
  };

  useEffect(() => {
    console.log(productdata);
    setformData({
      ...formData,
      sales_price: productdata?.avg_sales_price?.toFixed(3),
      purchase_price: productdata?.avg_purchase_price?.toFixed(3),
      box_sales_cost: productdata?.box_sales_cost?.toFixed(3),
      qty: 0,
    });
  }, [productdata]);

  const handlecancel = () => {
    setformData({
      invoice_no: "",
      invoice_date: "",
      ref_1: "",
      ref_2: "",
      purchase_unit: "1",
      tax_type: "",
      remark: "",
      supplier_invoice_no: "",
      supplier_invoice_date: "",
      product_id: "",
      product_name: "",
      supplier_id: "",
      purchase_price: "",
      qty: "",
      total_amount: "",
      sales_price: "",
      manufactured_date: "",
      expiry_date: "",
      manufacturer_id: "",
      product_code: "",
      storage_type: "",
      box_sales_cost: "",
    });
    setInputValue("");
    setproductData();
    setsupplierData("");
    setSupplierValue("");
  };

  const fields = (
    <>
      <div className="row">
        <div className="col-lg-4 col-12">
          <div className="card p-3" style={{ minHeight: "180px" }}>
            {InputField(
              "Invoice No",
              "invoice_no",
              "text",
              formData.invoice_no,
              handleChange,
              "Enter Invoice no",
              12
            )}
            {InputField(
              "Invoice Date",
              "invoice_date",
              "date",
              formData.invoice_date,
              handleChange,
              "Enter Invoice date",
              12
            )}
            {InputField(
              "Reference 1",
              "ref_1",
              "text",
              formData.ref_1,
              handleChange,
              "Enter reference 1",
              12
            )}
            {InputField(
              "Reference 2",
              "ref_2",
              "text",
              formData.ref_2,
              handleChange,
              "Enter reference 2",
              12
            )}
            {SelectOption(
              "Purchase Type",
              "purchase_unit",
              formData.purchase_unit,
              handleChange,
              "Select Purchase",
              [
                {
                  title: "Cash",
                  id: "1",
                },
                {
                  title: "Credit",
                  id: "2",
                },
              ]
            )}

            {SelectOption(
              "Tax Type",
              "tax_type",
              formData.tax_type,
              handleChange,
              "Select Tax",
              taxes
            )}
          </div>
        </div>
        <div className="col-lg-4 col-12">
          <div className="card mb-0 p-3">
            <div className={`form-group mb-2  d-flex align-items-center`}>
              <label className="col-4 text-verysmall">Customer</label>
              <div
                className="searchable-dd  d-flex w-100"
                style={{ maxHeight: "1rem" }}
              >
                <input
                  type="text"
                  className="text-small w-100"
                  value={SupplierValue}
                  onChange={(e) => handleSupplierChange(0, e.target.value)}
                  placeholder="Search Customer"
                  required
                />
                {SupplierValue && filteredSuppliers.length > 0 && (
                  <div className="custom-dropdown">
                    {filteredSuppliers.map((pro) => (
                      <div
                        key={pro.product_id}
                        className="dropdown-item"
                        onChange={(e) =>
                          handleChange({
                            target: {
                              name: "customer_id",
                              value: pro.customer_id,
                              pro_name: pro.name,
                            },
                          })
                        }
                        onClick={(e) => {
                          handleChange({
                            target: {
                              name: "customer_id",
                              value: pro.customer_id,
                              pro_name: pro.name,
                            },
                          });
                          setsupplierData(
                            supplier.find(
                              (item) => item.customer_id == pro.customer_id
                            )
                          );
                          setPreviousDue(pro?.last_remaining);
                        }}
                      >
                        {pro.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {InputField(
              "Address",
              "ref_1",
              "text",
              supplierdata?.address1 || "",
              () => {},
              " ",
              12,
              null,
              undefined,
              undefined,
              true
            )}
            {InputField(
              "Contact no",
              "ref_2",
              "text",
              supplierdata?.phone || "",
              () => {},
              "",
              12,
              null,
              undefined,
              undefined,
              true
            )}
            <div className="d-flex mt-2 column-gap-4">
              <span className="text-small font-weight-2">Balance</span>
              <span className="text-small font-weight-2">0.00</span>
            </div>
          </div>
          <div className="card p-2">
            {InputField(
              "Customer Invoice",
              "supplier_invoice_no",
              "text",
              formData?.supplier_invoice_no || "",
              handleChange,
              " ",
              12
            )}
            {InputField(
              "Invoice Date",
              "supplier_invoice_date",
              "date",
              formData?.supplier_invoice_date,
              handleChange,
              " ",
              12
            )}
          </div>
        </div>
      </div>
      <div className="col-lg-10 col-12">
        <div className="row">
          <div className={`form-group col-4 d-flex align-items-center`}>
            <label className="col-4 text-verysmall">Product</label>
            <div
              className="searchable-dd mb-2 w-100 d-flex"
              style={{ maxHeight: "1rem" }}
            >
              <input
                type="text"
                className="text-small w-100"
                value={inputValue}
                onChange={(e) => handleProductChange(0, e.target.value)}
                placeholder="Search Product"
                required
              />
              {inputValue && filteredProducts.length > 0 && (
                <div className="custom-dropdown">
                  {filteredProducts.map((pro) => (
                    <div
                      key={pro.product_id}
                      className="dropdown-item"
                      onChange={(e) =>
                        handleChange({
                          target: {
                            name: "product_id",
                            value: pro.product_id,
                            pro_name: pro.product_name,
                          },
                        })
                      }
                      onClick={(e) => {
                        handleChange({
                          target: {
                            name: "product_id",
                            value: pro.product_id,
                            pro_name: pro.product_name,
                          },
                        });
                        console.log(
                          products.find(
                            (item) => item.product_id == pro.product_id
                          )
                        );
                        setproductData(
                          products.find(
                            (item) => item.product_id == pro.product_id
                          )
                        );
                      }}
                    >
                      {pro.product_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Item code",
              "qty",
              "text",
              productdata?.product_code || "",
              () => {},
              " ",
              12,
              null,
              undefined,
              undefined,
              true
            )}
          </div>
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Storage type",
              "qty",
              "text",
              productdata?.storage_type || "",
              () => {},
              "Storage type",
              12,
              null,
              undefined,
              undefined,
              true
            )}
          </div>
        </div>
        <div className="row">
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Quantity",
              "qty",
              "number",
              formData.qty,
              handleChange,
              "Enter Quantity",
              12,
              null,
              undefined,
              productdata?.total_remaining_qty || 0
            )}
          </div>
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Sales Rate",
              "sales_price",
              "number",
              formData.sales_price,
              handleChange,
              "Enter Rate",
              12
            )}
          </div>
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Total amount",
              "total_amount",
              "number",
              formData?.total_amount,
              handleChange,
              "Enter Amount",
              12
            )}
          </div>
        </div>
        <div className="row">
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Box Sales Rate",
              "box_sales_cost",
              "number",
              formData.box_sales_cost,
              handleChange,
              "Enter Box Sales Rate",
              12
            )}
          </div>
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Price",
              "purchase_price",
              "number",
              formData.purchase_price,
              handleChange,
              "Enter Price",
              12
            )}
          </div>
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Manufactured Date",
              "manufactured_date",
              "date",
              formData.manufactured_date,
              handleChange,
              "Enter date",
              12
            )}
          </div>
          <div className={`form-group col-4  d-flex align-items-center`}>
            {InputField(
              "Expiry Date",
              "expiry_date",
              "date",
              formData.expiry_date,
              handleChange,
              "Enter Rate",
              12
            )}
          </div>
        </div>
      </div>
      <div className="col-lg-2 col-12 d-flex flex-column row-gap-2">
        <button
          className="btn btn-primary text-small w-75"
          onClick={() => handleAddRow()}
        >
          Add Row
        </button>
        <button
          className="btn btn-secondary text-small w-75"
          onClick={() => handlecancel()}
        >
          Cancel
        </button>
      </div>
    </>
  );

  const getTotalOld = () => {
    var sub_total = rows.reduce(
      (acc, item) => acc + (item.total_amount || 0),
      0
    );
    var dis =
      (rows.reduce((acc, item) => acc + (item.total_amount || 0), 0) *
        (discount ? parseFloat(discount) : 0)) /
      100;
    var varcount =
      (rows.reduce((acc, item) => acc + (item.total_amount || 0), 0) *
        (vat ? parseFloat(vat) : 0)) /
      100;
    // var total = sub_total - (dis + varcount);
    var total = sub_total - dis + varcount;
    return total;
  };

  const getTotal = () => {
    var sub_total = rows.reduce(
      (acc, item) => acc + (item.total_amount || 0),
      0
    );
    var dis = (sub_total * (discount ? parseFloat(discount) : 0)) / 100;
    var varcount = (sub_total * (vat ? parseFloat(vat) : 0)) / 100;
    var freight = freightCharges ? parseFloat(freightCharges) : 0;
    var other = otherCharges ? parseFloat(otherCharges) : 0;

    var total = sub_total + varcount + freight + other - dis;
    var roundOff = Math.round(total) - total; // Calculates the rounding difference
    var grandTotal = total + roundOff; // Grand total after rounding
    var balance = (previousDue ? parseFloat(previousDue) : 0) + grandTotal; // Balance = Previous Due + Grand Total

    return { sub_total, total, roundOff, grandTotal, balance };
  };

  return (
    // <div className="page-wrappers">
    <div className="page-content">
      <div className="row">
        <div className="col-6 d-flex column-gap-3 align-items-center">
          <button
            className="btn py-1 btn-secondary text-small"
            onClick={() => navigate("/Quotation_list")}
          >
            Back
          </button>
          <h3>{state.quotation_number}</h3>
        </div>
      </div>
      <NewCommonCardUi feilds={fields} />
      <div className="container-fluid mt-1 px-2 pb-4">
        <div className="row">
          <div className="card col-10">
            <div className="card-body">
              <div className="d-flex justify-content-end">
                {/* <button className="btn my-1 btn-primary py-1 btn-sm text-normal rounded-1"
                                        onClick={HandleSubmit}
                                        width={"20px"}>
                                        submit
                                    </button> */}
              </div>
              <div className="table-responsive" style={{ minHeight: "300px" }}>
                <table
                  id="example"
                  className="table table-striped table-sm table-bordered"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th className="text-small">S.No</th>
                      <th className="text-small">product Name</th>
                      <th className="text-small">itemcode</th>
                      <th className="text-small">warehouse</th>
                      <th className="text-small">Qty</th>
                      {/* <th className='text-small'>price per unit</th> */}
                      <th className="text-small">sales rate</th>
                      <th className="text-small">total amount</th>
                      <th className="text-small">manufactured date</th>
                      <th className="text-small">Expiry date</th>
                      <th className="text-small">storage type</th>
                      <th className="text-small">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      // <tr key={index}>
                      //     <td>{index + 1}</td>
                      //     <td>
                      //         <select
                      //             disabled={true}
                      //             name="manufacturer_id"
                      //             className="dd-input mt-1"
                      //             value={row.manufacturer_id}
                      //             onChange={(e) => handleInputChange(index, "manufacturer_id", e.target.value)}
                      //             required
                      //         >
                      //             <option value="">Select Manufacturer</option>
                      //             {Manufacturers.map((Manu) => (
                      //                 <option key={Manu.manufacturer_id} value={Manu.manufacturer_id}>
                      //                     {Manu.name}
                      //                 </option>
                      //             ))}
                      //         </select>
                      //     </td>
                      //     <td>
                      //         <select name="product_id"
                      //             className="dd-input mt-1"
                      //             disabled={true}
                      //             value={row.product_id}
                      //             onChange={(e) => handleInputChange(index, "product_id", e.target.value)}
                      //             required>
                      //             <option value="">Select Product</option>
                      //             {products.map((pro) => (
                      //                 <option key={pro.id} value={pro.product_id}>
                      //                     {pro.product_name}
                      //                 </option>
                      //             ))}
                      //         </select>
                      //     </td>
                      //     <td>
                      //         <input
                      //             type="text"
                      //             disabled={true}
                      //             className="dd-input mt-1"
                      //             placeholder="Quantity"
                      //             value={row.qty}
                      //             onChange={(e) => handleInputChange(index, "qty", e.target.value)}
                      //             required
                      //         />
                      //     </td>

                      //     <td>
                      //         <img src="/assets/images/icons/delete.png"
                      //             className='m-1'
                      //             onClick={() => handleRemoveRow(index)}
                      //             width={"20px"} />
                      //     </td>
                      // </tr>
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{row.product_name}</td>
                        <td>{row.item_code}</td>
                        <td>{selectedWarehouse?.title}</td>
                        <td>{row.qty}</td>
                        {/* <td>{row.purchase_price}</td> */}
                        <td>{row.sales_price}</td>
                        <td>{row.total_amount}</td>
                        <td>{row.manufactured_date}</td>
                        <td>{row.expiry_date}</td>
                        <td>{row.storage_type}</td>
    
                         <img
                            className="mx-2"
                            src="/assets/images/icons/edit.png"
                            onClick={() =>
                                handleEditRow(index)}
                            style={{height: "16px"}}
                          />
                        <td>
                          <img
                            src="/assets/images/icons/delete.png"
                            className="m-1"
                            onClick={() => handleRemoveRow(index)}
                            width={"20px"}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-2 p-0 ps-1" style={{ height: "fit-content" }}>
            <div
              className="card py-2 border-black p-1"
              style={{ height: "fit-content" }}
            >
              {InputField(
                "Sub Total",
                "sub_total",
                "text",
                getTotal().sub_total,
                () => {},
                "",
                12,
                null,
                null,
                undefined,
                true
              )}

              <div
                className={`form-group mb-1 d-flex align-items-end col-${12}`}
              >
                <div className="col-4">
                  <label className="col-12 text-verysmall">{"Discount"}</label>
                  <div className="col-12">
                    <input
                      type={"text"}
                      value={discount}
                      onChange={(e) => {
                        setDiscount(e.target.value);
                      }}
                      className="text-verysmall col-9"
                      style={{ height: "1.5rem" }}
                      placeholder="00.0"
                    />
                    <label className="col-3 text-verysmall">%</label>
                  </div>
                </div>

                <div className="col-8">
                  <input
                    className="w-100 text-verysmall"
                    style={{ height: "1.5rem" }}
                    value={
                      (rows.reduce(
                        (acc, item) => acc + (item.total_amount || 0),
                        0
                      ) *
                        (discount ? parseFloat(discount) : 0)) /
                      100
                    }
                    disabled={true}
                  />
                </div>
              </div>

              <div
                className={`form-group mb-1 d-flex align-items-end col-${12}`}
              >
                <div className="col-4">
                  <label className="col-12 text-verysmall">{"VAT"}</label>
                  <div className="col-12">
                    <input
                      type={"text"}
                      value={vat}
                      onChange={(e) => {
                        setVat(e.target.value);
                      }}
                      className="text-verysmall col-9"
                      style={{ height: "1.5rem" }}
                      placeholder="00.0"
                    />
                    <label className="col-3 text-verysmall">%</label>
                  </div>
                </div>
                <div className="col-8">
                  <input
                    className="w-100 text-verysmall"
                    style={{ height: "1.5rem" }}
                    disabled={true}
                    value={
                      (rows.reduce(
                        (acc, item) => acc + (item.total_amount || 0),
                        0
                      ) *
                        (vat ? parseFloat(vat) : 0)) /
                      100
                    }
                  />
                </div>
              </div>

              {InputField(
                "Freight Charges  ",
                "freight_charges ",
                "number",
                freightCharges,
                (e) => {
                  setFreightCharges(e.target.value);
                }
              )}
              {InputField(
                "Other Charges  ",
                "other_charges",
                "number",
                otherCharges,
                (e) => {
                  setOtherCharges(e.target.value);
                }
              )}
              {InputField(
                "Previous Due  ",
                "Vat",
                "text",
                previousDue,
                () => {},
                "",
                12,
                0,
                "",
                undefined,
                true
              )}
              {InputField(
                "Total",
                "Vat",
                "text",
                getTotal().total.toFixed(3),
                () => {},
                "",
                12,
                0,
                "",
                undefined,
                true
              )}
              {InputField(
                "Round off",
                "round_off",
                "text",
                getTotal().roundOff.toFixed(3),
                () => {},
                "",
                12,
                0,
                "",
                undefined,
                true
              )}
              {InputField(
                "Grand Total",
                "Vat",
                "text",
                getTotal().grandTotal,
                () => {},
                "",
                12,
                0,
                "",
                undefined,
                true
              )}
              {InputField(
                "Balance",
                "Vat",
                "text",
                getTotal().balance,
                () => {},
                "",
                12,
                0,
                "",
                undefined,
                true
              )}
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <ProductForm
          selectedProduct={selectedProduct}
          closeModal={closeModal}
          refreshList={fetchProducts}
        />
      )}
      {showSupplierModal && (
        <SupplierForm
          // selectedSupplier={selectedSupplier}
          onClose={() => closeModal()}
          fetchSuppliers={fetchSuppliers}
        />
      )}
      <div
        className="fixed-bottom bg-white d-flex justify-content-center py-2 column-gap-3"
        style={{ height: "50px" }}
      >
        {/* <button className='btn-secondary btn py-0 text-small'>Cancel</button> */}
        <button
          className="btn-primary btn py-0 text-small"
          onClick={() => HandleSubmit()}
        >
          Submit
        </button>
      </div>
    </div>
    // </div>
  );
};

export default EditQuotation;
